import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  const yesItems = ['Llevan años juntos y saben que el amor sigue ahí.', 'Sienten que algo se enfrió, pero no quieren resignarse.', 'Desean profundizar la intimidad, no maquillarla.', 'Quieren guía clara, profesional y aplicable.', 'Entienden que una relación viva se cuida, se entrena y se elige.'];
  const noItems = ['No estás en pareja actualmente.', 'Buscas trucos rápidos o estímulos superficiales.', 'Esperas que algo cambie sin involucrarte.', 'Confundes intimidad con vulgaridad.'];
  return <section className="py-20 bg-[#0A0A0A] text-[#FAF7F2]" data-id="element-77">
      <div className="max-w-6xl mx-auto px-4" data-id="element-78">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-79">
          {/* YES Column */}
          <motion.div className="bg-[#111] p-8 md:p-12 rounded-lg border border-[#C5A55A]/20" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-80">
            <h3 className="text-2xl font-serif text-[#C5A55A] mb-8 border-b border-[#C5A55A]/30 pb-4" data-id="element-81">
              Esta inmersión ES para ti si…
            </h3>
            <ul className="space-y-6" data-id="element-82">
              {yesItems.map((item, idx) => <motion.li key={idx} className="flex items-start gap-4" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} data-id="element-83">
                  <div className="mt-1 bg-[#C5A55A]/10 p-1 rounded-full" data-id="element-84">
                    <Check className="w-5 h-5 text-[#C5A55A]" data-id="element-85" />
                  </div>
                  <p className="text-lg text-[#FAF7F2]/90 font-light" data-id="element-86">{item}</p>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* NO Column */}
          <motion.div className="bg-[#111] p-8 md:p-12 rounded-lg border border-[#B91C1C]/20" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-87">
            <h3 className="text-2xl font-serif text-[#B91C1C] mb-8 border-b border-[#B91C1C]/30 pb-4" data-id="element-88">
              Esta inmersión NO es para ti si…
            </h3>
            <ul className="space-y-6" data-id="element-89">
              {noItems.map((item, idx) => <motion.li key={idx} className="flex items-start gap-4" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} data-id="element-90">
                  <div className="mt-1 bg-[#B91C1C]/10 p-1 rounded-full" data-id="element-91">
                    <X className="w-5 h-5 text-[#B91C1C]" data-id="element-92" />
                  </div>
                  <p className="text-lg text-[#FAF7F2]/70 font-light" data-id="element-93">{item}</p>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}